import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import { Spinner } from '@realvisor/ui';

export default function AuthLayout() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex flex-1">
        {/* Left side - Form */}
        <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <Outlet />
          </div>
        </div>

        {/* Right side - Branding */}
        <div className="relative hidden w-0 flex-1 lg:block">
          <div className="absolute inset-0 bg-gradient-to-br from-primary-600 to-primary-800">
            <div className="flex h-full flex-col items-center justify-center p-12 text-white">
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-white/10">
                <svg className="h-10 w-10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 9L12 5L21 9V15L12 19L3 15V9Z" />
                  <path d="M12 5V19" />
                </svg>
              </div>
              <h1 className="mt-6 text-3xl font-bold">RealVisor</h1>
              <p className="mt-2 text-center text-lg text-primary-100">
                CRM pro moderní realitní kanceláře
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-white px-4 py-4">
        <div className="text-center text-sm text-gray-500">
          © {new Date().getFullYear()} RealVisor. Design & Development by <span className="font-medium text-gray-700">David Choc</span>
        </div>
      </footer>
    </div>
  );
}
